import compact from "lodash/compact";
import locale from "./buildScriptActionsMenuItems.locale";
export default (script, onOpenScriptEditorPanel, onDeleteScript) => compact([
    {
        text: locale.EDIT_SCRIPT,
        onClick: () => {
            onOpenScriptEditorPanel && onOpenScriptEditorPanel(script);
        }
    },
    {
        text: locale.DELETE_SCRIPT,
        confirm: {
            title: locale.CONFIRM_DELETE_SCRIPT_TEXT,
            header: locale.CONFIRM_DELETE_SCRIPT_HEADER,
            callback: () => {
                onDeleteScript && onDeleteScript(script.Id);
            }
        }
    }
]);
